export default __webpack_public_path__ + "static/media/loading.081f5225.svg";